// console.log('=== INFINITE SCROLL SCRIPT LOADED ===');

document.addEventListener('DOMContentLoaded', function() {
  // console.log('DOM loaded, initializing infinite scroll');
  
  const section = document.querySelector('#CollectionSection');
  if (!section) {
    // console.error('ERROR: CollectionSection not found');
    return;
  }
  
  // console.log('✓ CollectionSection found');

  // Get settings from JSON script tag
  const settingsScript = document.getElementById('infinite-scroll-settings');
  if (!settingsScript) {
    // console.error('ERROR: Settings script tag not found');
    return;
  }

  let settings;
  try {
    settings = JSON.parse(settingsScript.textContent);
    // console.log('✓ Settings loaded:', settings);
    // console.log('  - Enable banners:', settings.enableBanners);
    // console.log('  - Number of banner blocks:', settings.banners ? settings.banners.length : 0);
    // console.log('  - Banner blocks:', settings.banners);
  } catch (error) {
    // console.error('ERROR parsing settings JSON:', error);
    return;
  }

  let isLoading = false;
  let currentPage = 1;
  let bannerIndex = 0; // Track which banner to show next
  let firstPageBannersInserted = false; // Track if we've already inserted first page banners

  // Insert banners on first page only
  function insertFirstPageBanners(container) {
    if (!settings.enableBanners) {
      // console.log('Banners disabled in settings');
      return;
    }
    
    if (!settings.banners || settings.banners.length === 0) {
      // console.log('No banner blocks configured');
      return;
    }
    
    if (firstPageBannersInserted) {
      // console.log('First page banners already inserted');
      return;
    }
    
    const allProducts = Array.from(container.querySelectorAll('.grid__item:not(.collection-banner)'));
    // console.log('Found', allProducts.length, 'total products on first page');
    
    if (allProducts.length === 0) {
      // console.log('No products found');
      return;
    }
    
    // First banner: after 8th product
    if (allProducts.length >= 8 && settings.banners.length >= 1) {
      const eighthProduct = allProducts[7]; // 0-indexed
      
      // Check if banner already exists after this product
      if (!eighthProduct.nextElementSibling?.classList.contains('collection-banner')) {
        const banner1 = createBanner();
        
        if (banner1) {
          // Insert AFTER the 8th product
          if (eighthProduct.nextSibling) {
            eighthProduct.parentNode.insertBefore(banner1, eighthProduct.nextSibling);
          } else {
            eighthProduct.parentNode.appendChild(banner1);
          }
          
          // console.log('✓ Inserted first banner after 8th product');
        }
      }
    }
    
    // Second banner: after last product on first page (before Load More)
    if (allProducts.length > 8 && settings.banners.length >= 2) {
      const lastProduct = allProducts[allProducts.length - 1];
      
      // Check if banner already exists after this product
      if (!lastProduct.nextElementSibling?.classList.contains('collection-banner')) {
        const banner2 = createBanner();
        
        if (banner2) {
          // Insert AFTER the last product
          if (lastProduct.nextSibling) {
            lastProduct.parentNode.insertBefore(banner2, lastProduct.nextSibling);
          } else {
            lastProduct.parentNode.appendChild(banner2);
          }
          
          // console.log('✓ Inserted second banner after last product');
        }
      }
    }
    
    firstPageBannersInserted = true;
  }

  // Create banner element
  function createBanner() {
    // Check if we have any banners configured
    if (!settings.banners || settings.banners.length === 0) {
      // console.log('No banner blocks configured');
      return null;
    }
    
    // Get the current banner based on index
    const currentBanner = settings.banners[bannerIndex];
    
    // Increment index for next time, loop back to 0 if we've shown all banners
    bannerIndex = (bannerIndex + 1) % settings.banners.length;
    
    // console.log('Creating banner', (bannerIndex === 0 ? settings.banners.length : bannerIndex), 'of', settings.banners.length);
    
    // Create banner element - use <a> if link exists, <div> otherwise
    const banner = currentBanner.link ? document.createElement('a') : document.createElement('div');
    banner.className = 'collection-banner';
    
    // If link exists, set href
    if (currentBanner.link) {
      banner.href = currentBanner.link;
    }
    
    // Add data attributes for column spanning
    banner.setAttribute('data-span-desktop', currentBanner.spanDesktop || 4);
    banner.setAttribute('data-span-mobile', currentBanner.spanMobile || 2);
    
    // Add data attributes for banner height
    banner.setAttribute('data-height-desktop', currentBanner.heightDesktop || 0);
    banner.setAttribute('data-height-mobile', currentBanner.heightMobile || 0);
    
    // Set CSS custom properties for dynamic heights (0 means auto)
    const desktopHeight = currentBanner.heightDesktop && currentBanner.heightDesktop > 0 ? currentBanner.heightDesktop + 'px' : 'auto';
    const mobileHeight = currentBanner.heightMobile && currentBanner.heightMobile > 0 ? currentBanner.heightMobile + 'px' : 'auto';
    banner.style.setProperty('--banner-height-desktop', desktopHeight);
    banner.style.setProperty('--banner-height-mobile', mobileHeight);
    
    // Determine which image to use based on viewport and availability
    // Priority: If mobile exists, use it on mobile. If desktop exists, use it on desktop.
    // Fallback: If only one is set, use it for both
    const isMobile = window.innerWidth <= 768;
    let bannerImageUrl;
    
    if (isMobile) {
      // On mobile: use mobile image if available, otherwise desktop, otherwise fallback
      bannerImageUrl = currentBanner.imageMobile || currentBanner.imageDesktop || '/assets/hero-banner-desktop-sample.jpg';
    } else {
      // On desktop: use desktop image if available, otherwise mobile, otherwise fallback
      bannerImageUrl = currentBanner.imageDesktop || currentBanner.imageMobile || '/assets/hero-banner-desktop-sample.jpg';
    }
    
    banner.innerHTML = `<img src="${bannerImageUrl}" alt="Collection Banner">`;
    
    // console.log('Created banner element with image:', bannerImageUrl);
    return banner;
  }

  // Load more products via AJAX
  function loadMore() {
    // console.log('>>> loadMore() called <<<');
    
    if (isLoading) {
      // console.log('Already loading, skipping...');
      return;
    }
    
    const loadMoreContainer = section.querySelector('.pagination-infinite-scroll');
    if (!loadMoreContainer) {
      // console.error('ERROR: pagination-infinite-scroll container not found');
      return;
    }
    
    const nextUrl = loadMoreContainer.dataset.nextUrl;
    if (!nextUrl) {
      // console.error('ERROR: No next URL found');
      return;
    }
    
    // console.log('Loading more products from:', nextUrl);
    
    isLoading = true;
    const loadingSpinner = loadMoreContainer.querySelector('.infinite-scroll-loading');
    const loadMoreBtn = loadMoreContainer.querySelector('.load-more-btn');
    
    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
    if (loadingSpinner) loadingSpinner.style.display = 'block';
    
    fetch(nextUrl)
      .then(response => {
        // console.log('Response status:', response.status);
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // console.log('Parsed document received');
        
        // Get new products
        const newProductsContainer = doc.querySelector('.product-grid-container');
        const currentProductContainer = section.querySelector('.product-grid-container');
        
        // console.log('New products container:', newProductsContainer);
        // console.log('Current product container:', currentProductContainer);
        
        if (newProductsContainer && currentProductContainer) {
          // Count how many products are already in the container BEFORE appending
          const productsBeforeLoad = currentProductContainer.querySelectorAll('.grid__item:not(.collection-banner)').length;
          // console.log('Products already in container before loading:', productsBeforeLoad);
          
          // Append new products
          const newItems = Array.from(newProductsContainer.children);
          // console.log('Number of new items:', newItems.length);
          
          newItems.forEach(item => {
            const clonedItem = item.cloneNode(true);
            
            // Remove aos-animate class from ALL elements to ensure images start at opacity 0
            clonedItem.classList.remove('aos-animate');
            const aosElements = clonedItem.querySelectorAll('[data-aos], .aos-animate');
            aosElements.forEach(el => {
              el.classList.remove('aos-animate');
            });
            
            // Also remove any inline styles that might override opacity
            const images = clonedItem.querySelectorAll('img');
            images.forEach(img => {
              img.style.opacity = '';
            });
            
            currentProductContainer.appendChild(clonedItem);
          });
          
            initQuickShopButtons(currentProductContainer);
          // console.log('✓ Products appended successfully');
          
          // Reinitialize AOS to detect new elements
          // Let AOS naturally animate them when user scrolls to them
          if (typeof AOS !== 'undefined') {
            setTimeout(() => {
              // console.log('Refreshing AOS for new products');
              if (typeof AOS.refreshHard === 'function') {
                AOS.refreshHard();
              } else {
                AOS.refresh();
              }
              // console.log('✓ AOS refreshed - new products will animate on scroll');
            }, 100);
          }
          
          // Don't insert banners on subsequent pages - only on first page
        } else {
          // console.error('ERROR: Could not find product containers');
        }
        
        // Update next URL
        const nextPagination = doc.querySelector('.pagination-infinite-scroll');
        // console.log('Next pagination element:', nextPagination);
        
        if (nextPagination && nextPagination.dataset.nextUrl) {
          loadMoreContainer.dataset.nextUrl = nextPagination.dataset.nextUrl;
          if (loadMoreBtn) loadMoreBtn.style.display = 'inline-block';
          // console.log('Updated next URL:', nextPagination.dataset.nextUrl);
        } else {
          // No more pages
          loadMoreContainer.style.display = 'none';
          // console.log('No more pages to load');
        }
        
        currentPage++;
        isLoading = false;
        if (loadingSpinner) loadingSpinner.style.display = 'none';
        // console.log('=== Load complete ===');
      })
      .catch(error => {
        // console.error('FETCH ERROR:', error);
        isLoading = false;
        if (loadMoreBtn) loadMoreBtn.style.display = 'inline-block';
        if (loadingSpinner) loadingSpinner.style.display = 'none';
      });
  }

  // Initialize - Load More button is always enabled
  const loadMoreBtn = section.querySelector('[data-load-more]');
  // console.log('Looking for Load More button...');
  // console.log('Load More button found:', loadMoreBtn);
  
  if (loadMoreBtn) {
    // console.log('✓ Attaching click event listener...');
    loadMoreBtn.addEventListener('click', function(e) {
      // console.log('!!! BUTTON CLICKED !!!');
      e.preventDefault();
      e.stopPropagation();
      loadMore();
      return false;
    });
    // console.log('✓ Click event listener attached');
  } else {
    // console.error('ERROR: Load More button not found with selector [data-load-more]');
    
    // Debug: Check what pagination elements exist
    const allButtons = section.querySelectorAll('button');
    // console.log('All buttons found:', allButtons);
    const pagination = section.querySelector('.pagination-infinite-scroll');
    // console.log('Pagination container:', pagination);
  }
  
  // Insert initial banners on first page load
  if (settings.enableBanners) {
    const productContainer = section.querySelector('.product-grid-container');
    if (productContainer) {
      insertFirstPageBanners(productContainer);
    }
  }
  
  // Re-insert banners on window resize (only on first page)
  // Only trigger on width changes to avoid mobile Safari address bar hide/show issues
  let resizeTimer;
  let lastWidth = window.innerWidth;
  
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const currentWidth = window.innerWidth;
      
      // Only re-insert banners if width actually changed (not just height from mobile UI)
      if (currentWidth !== lastWidth) {
        // console.log('Width changed from', lastWidth, 'to', currentWidth, '- re-inserting banners');
        lastWidth = currentWidth;
        
        const productContainer = section.querySelector('.product-grid-container');
        if (productContainer) {
          // Remove existing banners
          productContainer.querySelectorAll('.collection-banner').forEach(b => b.remove());
          
          // Reset and re-insert first page banners
          firstPageBannersInserted = false;
          bannerIndex = 0;
          insertFirstPageBanners(productContainer);
        }
      } else {
        // console.log('Height-only resize detected (likely mobile Safari UI) - skipping banner re-insertion');
      }
    }, 500); // Increased debounce for mobile
  });
  
  // console.log('=== INFINITE SCROLL INITIALIZED ===');
});

// Listen for Shopify theme editor section events
document.addEventListener('shopify:section:load', function(event) {
  reinitializeBanners();
});

document.addEventListener('shopify:section:select', function(event) {
  reinitializeBanners();
});

document.addEventListener('shopify:block:select', function(event) {
  reinitializeBanners();
});

function reinitializeBanners() {
  const section = document.querySelector('#CollectionSection');
  if (!section) return;

  const productContainer = section.querySelector('.product-grid-container');
  if (!productContainer) return;

  // Remove existing banners
  productContainer.querySelectorAll('.collection-banner').forEach(banner => banner.remove());

  // Re-read settings from the script tag
  const settingsScript = document.getElementById('infinite-scroll-settings');
  if (!settingsScript) return;

  try {
    const settings = JSON.parse(settingsScript.textContent);
    
    // Re-insert banners with updated settings if enabled
    if (settings.enableBanners && settings.banners && settings.banners.length > 0) {
      const allProducts = Array.from(productContainer.querySelectorAll('.grid__item:not(.collection-banner)'));
      
      if (allProducts.length === 0) return;
      
      let bannerIndex = 0;
      
      // Helper function to create banner with updated settings
      function createBannerFromSettings(bannerConfig) {
        // Create banner element - use <a> if link exists, <div> otherwise
        const banner = bannerConfig.link ? document.createElement('a') : document.createElement('div');
        banner.className = 'collection-banner';
        
        // If link exists, set href
        if (bannerConfig.link) {
          banner.href = bannerConfig.link;
        }
        
        banner.setAttribute('data-span-desktop', bannerConfig.spanDesktop || 4);
        banner.setAttribute('data-span-mobile', bannerConfig.spanMobile || 2);
        banner.setAttribute('data-height-desktop', bannerConfig.heightDesktop || 0);
        banner.setAttribute('data-height-mobile', bannerConfig.heightMobile || 0);
        
        const desktopHeight = bannerConfig.heightDesktop && bannerConfig.heightDesktop > 0 ? bannerConfig.heightDesktop + 'px' : 'auto';
        const mobileHeight = bannerConfig.heightMobile && bannerConfig.heightMobile > 0 ? bannerConfig.heightMobile + 'px' : 'auto';
        banner.style.setProperty('--banner-height-desktop', desktopHeight);
        banner.style.setProperty('--banner-height-mobile', mobileHeight);
        
        const isMobile = window.innerWidth <= 768;
        let bannerImageUrl;
        
        if (isMobile) {
          bannerImageUrl = bannerConfig.imageMobile || bannerConfig.imageDesktop || '/assets/hero-banner-desktop-sample.jpg';
        } else {
          bannerImageUrl = bannerConfig.imageDesktop || bannerConfig.imageMobile || '/assets/hero-banner-desktop-sample.jpg';
        }
        
        banner.innerHTML = `<img src="${bannerImageUrl}" alt="Collection Banner">`;
        
        return banner;
      }
      
      // First banner: after 8th product
      if (allProducts.length >= 8 && settings.banners.length >= 1) {
        const eighthProduct = allProducts[7];
        const banner1 = createBannerFromSettings(settings.banners[0]);
        
        if (eighthProduct.nextSibling) {
          eighthProduct.parentNode.insertBefore(banner1, eighthProduct.nextSibling);
        } else {
          eighthProduct.parentNode.appendChild(banner1);
        }
      }
      
      // Second banner: after last product
      if (allProducts.length > 8 && settings.banners.length >= 2) {
        const lastProduct = allProducts[allProducts.length - 1];
        const banner2 = createBannerFromSettings(settings.banners[1]);
        
        if (lastProduct.nextSibling) {
          lastProduct.parentNode.insertBefore(banner2, lastProduct.nextSibling);
        } else {
          lastProduct.parentNode.appendChild(banner2);
        }
      }
    }
  } catch (error) {
    console.error('Error reinitializing banners:', error);
  }
}
